import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M1.767.98C.954.98.297 1.525.297 2.2v2.438c0 .674.657 1.22 1.47 1.22s1.47-.546 1.47-1.22v-1.22h2.941v12.193h-1.47c-.813 0-1.47.545-1.47 1.22s.657 1.219 1.47 1.219h5.881c.813 0 1.47-.545 1.47-1.22s-.657-1.219-1.47-1.219h-1.47V3.42h2.94v1.219c0 .674.657 1.22 1.47 1.22.814 0 1.47-.546 1.47-1.22V2.199C15 1.525 14.344.98 13.53.98H1.768"
    }, null, -1)
  ]))]))
}
export default { render: render }